export default __webpack_public_path__ + "static/media/notFound.b2866aab.jpg";